import React, { useRef, useState } from "react";
import { Button, Column } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";

export const CON_TransferenciasCuentasFinancieras_ = () => {
  const [data, setData] = useState([])
  const { CON_Transferencias: { function_CON_Transferencias_Listar } } = require('neftis7_apicaller');
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      
      const setData = async () => {
        try {
          //await function_NOEXISTE(Item.IdDocVenta)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  return (
    <PaginaListado
      Titulo="TRANSFERENCIAS DE CUENTAS FINANCIERAS"
      funcion={function_CON_Transferencias_Listar}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/CON_TransferenciasCuentasFinancieras_ModificacionCreacion/--NUEVO--" visible={false} />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdTransferencia"
            urlEdicion="/CON_Transferencias_ModificacionCreacion"
          > 
            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={false} />
            </Column>

            <Column caption="Código" dataField="IdTransferencia" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Concepto" dataField="Concepto" width="100%" minWidth={100} alignment="Left" dataType="string" />
            <Column caption="Observación" dataField="Observacion" width="200" alignment="Left" dataType="string" />
            <Column caption="Importe" dataField="ImporteOrigen" width="150" alignment="Right" dataType="number" format="currency" />


            <Column caption="Origen" alignment="Center">
              <Column caption="Cuenta Financiera" dataField="CuentaFinancieraOrigen" width="150" alignment="Left" dataType="string" />
              <Column caption="Moneda" dataField="MonedaOrigen" width="100" alignment="Left" dataType="string" />
              <Column caption="Cot." dataField="CotizacionOrigen" width="70" alignment="Right" dataType="number" format="currency" />
            </Column>
            <Column caption="Destino" alignment="Center">
              <Column caption="CuentaFinanciera" dataField="CuentaFinancieraDestino" width="150" alignment="Left" dataType="string" />
              <Column caption="Moneda" dataField="MonedaDestino" width="100" alignment="Left" dataType="string" />
              <Column caption="Cot." dataField="CotizacionDestino" width="70" alignment="Right" dataType="number" format="currency" />
            </Column>

            <Column caption="Estado" dataField="TODOS_Estados_Descripcion" width="100" alignment="Left" dataType="string" />
            <Column caption="Terminal" dataField="Terminal" width="100" alignment="Right" dataType="number" />

          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
